<template>
    <div class="wallet-withdraw-results">
        <div
            class="wallet-withdraw-results__result"
            :class="{'wallet-withdraw-results__result--warning': result.warning}"
            v-for="result in getResults"
            :key="result.id"
        >
            <p class="wallet-withdraw-results__label">
                {{ result.label }}
            </p>

            <p class="wallet-withdraw-results__label">
                {{ result.value }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "WalletWithdrawResults",
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
    computed: {
        getResults() {
            const rows = [
                {
                    id: 0,
                    label: this.$t('wallet.networkFee'),
                    value: this.form.withdrawFee,
                },
                {
                    id: 1,
                    label: this.$t('wallet.networkMin'),
                    value: this.form.withdrawMin,
                },
            ];
            if (this.form.imexCommission != null) {
                rows.push({
                    id: 2,
                    label: this.$t('wallet.imexCommission'),
                    value: this.form.imexCommission,
                });
            }
            const quota = this.form.kucoinQuota;
            if (quota != null) {
                // withdrawFee/withdrawMin выше приходят из общего network()-списка, у которого
                // для KuCoin своего источника нет (см. WalletService.getNetwork()) — эти два
                // ряда добавляют реальную комиссию/минимум конкретно с KuCoin
                // (GET /wallet/withdraw-quota, подключено 2026-09-11).
                rows.push({
                    id: 3,
                    label: this.$t('wallet.networkFee'),
                    value: quota.withdrawMinFee,
                });
                rows.push({
                    id: 4,
                    label: this.$t('wallet.networkMin'),
                    value: quota.withdrawMinSize,
                });
                if (quota.isWithdrawEnabled === false) {
                    rows.push({
                        id: 5,
                        label: this.$t('wallet.withdrawUnavailable'),
                        value: quota.reason || this.$t('wallet.withdrawUnavailable'),
                        warning: true,
                    });
                }
            }
            return rows;
        },
    },
};
</script>

<style lang="scss">
.wallet-withdraw-results {
    display: flex;
    flex-direction: column;
    grid-row-gap: 4px;

    .wallet-withdraw-results__result {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .wallet-withdraw-results__label {
        font-size: 12px;
        line-height: 17px;
        color: $txt-main;
    }

    .wallet-withdraw-results__result--warning .wallet-withdraw-results__label {
        color: $status-red;
    }
}
</style>
